import * as React from "react";
import ReceiptHelper from "../../Utilities/Domain/ReceiptHelper";
import { isTrainingMode } from "../../Utilities/Platform/Options/Options";
import { type ComponentType } from "../Forms/DragDrop/DragDropTypes";

type Props = {
    components: Array<ComponentType>;
    data: Record<string, any>;
    width: number;
    onReady?: () => void;
};

type State = {
    text: string;
};

export default class TextReceipt extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            text: ReceiptHelper.createTextReceipt(props.components, props.data, props.width, isTrainingMode()),
        };
    }

    public componentDidMount(): void {
        this.props.onReady?.();
    }

    public componentDidUpdate(prevProps: Readonly<Props>): void {
        if(prevProps.data !== this.props.data || prevProps.components !== this.props.components) {
            const text = ReceiptHelper.createTextReceipt(
                this.props.components,
                this.props.data,
                this.props.width,
                isTrainingMode()
            );

            this.setState({
                text,
            });
        }

        if(prevProps.onReady !== this.props.onReady) {
            this.props.onReady?.();
        }
    }

    public render(): React.ReactNode {
        return (
            <React.Fragment>
                {this.state.text}
            </React.Fragment>
        );
    }
}
